<template>
	<div v-if="show" class="login-wrap">
		<!-- 背景动态光晕 -->
		<div class="bg-orb bg-orb-1"></div>
		<div class="bg-orb bg-orb-2"></div>
		<div class="bg-orb bg-orb-3"></div>
		<!-- 装饰性流动线条 -->
		<div class="line-deco line-deco-1"></div>
		<div class="line-deco line-deco-2"></div>

		<!-- 登录卡片：整体滑动入场 -->
		<div class="login-card">
			<div class="info-title slide-item" style="animation-delay: 0.1s;">
				<img v-if="login_type==0" class="school-icon" :src="info.img" alt="school icon" />
				<div :style="login_type==1?'margin: auto;':''" class="school-name">{{ info.name || '智慧管理系统' }}</div>
			</div>

			<el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
				class="demo-ruleForm login-container">
				<h3 class="title slide-item" style="animation-delay: 0.2s;">用户登录</h3>

				<el-form-item prop="username" class="slide-item" style="animation-delay: 0.3s;">
					<el-input type="text" v-model="ruleForm.username" auto-complete="off" placeholder="账号" prefix-icon="el-icon-user"></el-input>
				</el-form-item>

				<el-form-item prop="password" class="slide-item" style="animation-delay: 0.4s;">
					<el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="密码" prefix-icon="el-icon-lock"></el-input>
				</el-form-item>

				<!-- 身份选择：滑动卡片效果 -->
				<el-form-item class="identity-item slide-item" style="animation-delay: 0.5s;">
					<div class="identity-label">选择身份</div>
					<div class="identity-group-wrapper">
						<el-radio-group v-model="selectedIdentity" class="identity-group">
							<el-radio-button label="0" class="identity-card">机构或学校</el-radio-button>
							<el-radio-button label="1" class="identity-card">政府部门</el-radio-button>
							<el-radio-button label="2" class="identity-card">赛事主办方</el-radio-button>
							<el-radio-button label="3" class="identity-card">系统管理员</el-radio-button>
						</el-radio-group>
					</div>
				</el-form-item>

				<el-form-item style="width:100%; animation-delay: 0.6s;" class="slide-item">
					<el-button type="primary" style="width:100%;" @click="submitForm('ruleForm')"
						:loading="logining">登 录</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
	<div class="no-block" v-else>
		<div class="no-text">网址错误，请确认名称是否正确</div>
		<img class="no-scool" src="https://logo-1305194676.cos.ap-guangzhou.myqcloud.com/wuguanzhudianpu.png" alt="error" />
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		name: 'login',
		data() {
			return {
				logining: false,
				ruleForm: {
					username: '',
					password: '',
				},
				rules: {
					username: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}]
				},
				info: {
					id: 0,
					name: "",
					img: ""
				},
				show: true,
				login_type: 0,
				selectedIdentity: 0
			}
		},
		created() {
			// var params = window.location.pathname.split('/')
			// params = decodeURIComponent(params[params.length - 1])
			// if (params) {
			// 	if (params[0] == 'c') {
			// 		var t = 1
			// 		this.login_type = 1
			// 		var sid = params.slice(1)
			// 	} else {
			// 		var t = 0
			// 		this.login_type = 0
			// 		var sid = params
			// 	}
			// 	axios({
			// 		method: 'post',
			// 		url: "https://www.kejiaoshu.com:8080/public/getComName",
			// 		data: { t: t, n: sid },
			// 		header: { 'Content-Type': "application/x-www-form-urlencoded" }
			// 	}).then(res => {
			// 		if (res.data) {
			// 			this.$message.success('欢迎登录' + sid + '任务管理系统')
			// 			document.title = sid
			// 			this.info.name = sid
			// 			this.info.id = res.data[0]
			// 			this.info.img = 'https://xuezicyi-1305194676.cos.ap-guangzhou.myqcloud.com/schoolicon_' + res.data[0] + '.png'
			// 		} else {
			// 			this.$message.error('网址输入错误！')
			// 			this.show = false
			// 			return false
			// 		}
			// 	})
			// } else {
			// 	this.login_type = 2
			// }
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						this.logining = true
						setTimeout(() => {
							axios({
								method: 'post',
								url: 'https://www.kejiaoshu.com:8080/admini/toLogin',
								data: {
									i:this.selectedIdentity,
									c: this.ruleForm.username,
									k: this.ruleForm.password,
									id: this.info.id,
									role: this.selectedIdentity
								},
								header: { 'Content-Type': "application/x-www-form-urlencoded" }
							}).then(res => {
								if (res.data) {
									localStorage.setItem('token', res.data.data.token)
									this.logining = false
									this.$store.commit('login', {
										type: this.selectedIdentity,
										tname: this.info.name,
										tid: this.info.id,
										uname: res.data.data.n,
										icon: this.info.img
									})
									console.log(this.selectedIdentity,1213)
									this.$router.push({ path: '/company/statistics' })
									// switch(this.selectedIdentity){
									// 	case 0:
									// 		this.$router.push({ path: '/school/statistics' })
									// 		break
									// 	case 1:
									// 		this.$router.push({ path: '/company/statistics' })
									// 		break
									// 	case 2:
									// 		this.$router.push({ path: '/contest/statistics' })
									// 		break
									// 	case 3:
									// 		this.$router.push({ path: '/admini/statistics' })
									// 		break
									// }
								} else {
									this.$message.error('账户或密码错误！')
									this.logining = false
									return false
								}
							})
						}, 1000)
					} else {
						this.$message.error('请输入用户名密码！')
						this.logining = false
						return false
					}
				})
			},
		}
	}
</script>

<style scoped>
	/* ===== 全局背景与光晕 ===== */
	.login-wrap {
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: 100vh;
		background: #0b0f19;
		position: relative;
		overflow: hidden;
		font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
	}

	/* 动态光晕 */
	.bg-orb {
		position: absolute;
		border-radius: 50%;
		filter: blur(80px);
		opacity: 0.6;
		z-index: 0;
		animation: floatOrb 14s ease-in-out infinite alternate;
	}
	.bg-orb-1 {
		width: 600px;
		height: 600px;
		background: radial-gradient(circle, rgba(56, 189, 248, 0.4), transparent 70%);
		top: -200px;
		right: -150px;
		animation-delay: 0s;
	}
	.bg-orb-2 {
		width: 500px;
		height: 500px;
		background: radial-gradient(circle, rgba(99, 102, 241, 0.4), transparent 70%);
		bottom: -150px;
		left: -100px;
		animation-delay: -5s;
	}
	.bg-orb-3 {
		width: 300px;
		height: 300px;
		background: radial-gradient(circle, rgba(236, 72, 153, 0.25), transparent 70%);
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		animation-delay: -10s;
	}
	@keyframes floatOrb {
		0% { transform: translate(0, 0) scale(1); }
		100% { transform: translate(40px, -30px) scale(1.15); }
	}

	/* 装饰性流动线条 */
	.line-deco {
		position: absolute;
		z-index: 1;
		background: linear-gradient(90deg, transparent, rgba(56, 189, 248, 0.2), transparent);
		height: 1px;
		width: 60%;
		animation: lineSlide 8s linear infinite;
	}
	.line-deco-1 {
		top: 15%;
		left: -20%;
		animation-delay: 0s;
	}
	.line-deco-2 {
		bottom: 20%;
		right: -20%;
		width: 40%;
		animation-delay: -4s;
	}
	@keyframes lineSlide {
		0% { transform: translateX(-100%) scaleX(0.5); opacity: 0; }
		50% { opacity: 1; }
		100% { transform: translateX(200%) scaleX(1); opacity: 0; }
	}

	/* ===== 登录卡片：滑动入场 ===== */
	.login-card {
		position: relative;
		z-index: 10;
		width: 440px;
		padding: 20px 20px 30px 20px;
		background: rgba(255, 255, 255, 0.04);
		backdrop-filter: blur(24px) saturate(180%);
		-webkit-backdrop-filter: blur(24px) saturate(180%);
		border-radius: 28px;
		border: 1px solid rgba(255, 255, 255, 0.08);
		box-shadow: 0 40px 80px -20px rgba(0, 0, 0, 0.8), inset 0 0 0 1px rgba(255, 255, 255, 0.05);
		transition: transform 0.3s ease, box-shadow 0.3s ease;
		animation: cardSlideUp 0.9s cubic-bezier(0.34, 1.56, 0.64, 1) both;
	}
	@keyframes cardSlideUp {
		0% {
			opacity: 0;
			transform: translateY(60px) scale(0.96);
		}
		100% {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}
	.login-card:hover {
		transform: translateY(-4px);
		box-shadow: 0 50px 100px -20px rgba(0, 0, 0, 0.9), inset 0 0 0 1px rgba(255, 255, 255, 0.08);
	}

	/* ===== 内部元素滑动入场 ===== */
	.slide-item {
		opacity: 0;
		animation: itemSlideUp 0.6s cubic-bezier(0.23, 1, 0.32, 1) both;
	}
	@keyframes itemSlideUp {
		0% {
			opacity: 0;
			transform: translateY(24px);
		}
		100% {
			opacity: 1;
			transform: translateY(0);
		}
	}

	/* ===== 头部信息 ===== */
	.info-title {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px 0 20px 0;
		gap: 16px;
		border-bottom: 1px solid rgba(255, 255, 255, 0.05);
		margin-bottom: 20px;
	}
	.school-icon {
		width: 56px;
		height: 56px;
		border-radius: 16px;
		background: rgba(255, 255, 255, 0.06);
		padding: 6px;
		object-fit: contain;
		border: 1px solid rgba(255, 255, 255, 0.08);
		box-shadow: 0 8px 20px -8px rgba(0, 0, 0, 0.5);
		transition: transform 0.4s ease;
	}
	.school-icon:hover {
		transform: rotate(-4deg) scale(1.05);
	}
	.school-name {
		font-size: 24px;
		font-weight: 600;
		background: linear-gradient(135deg, #e2e8f0 0%, #94a3b8 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
		letter-spacing: 2px;
		text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
	}

	/* ===== 表单容器 ===== */
	.login-container {
		padding: 0 4px;
	}
	.title {
		margin: 0 0 28px 0;
		text-align: center;
		font-size: 22px;
		font-weight: 500;
		color: #f1f5f9;
		letter-spacing: 4px;
	}

	/* ===== 覆写 Element UI 样式 ===== */
	::v-deep .el-input__inner {
		background: rgba(255, 255, 255, 0.04) !important;
		border: 1px solid rgba(255, 255, 255, 0.12) !important;
		border-radius: 12px !important;
		height: 50px !important;
		line-height: 50px !important;
		color: #f8fafc !important;
		font-size: 15px !important;
		padding-left: 44px !important;
		transition: all 0.3s ease !important;
		box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2) !important;
	}
	::v-deep .el-input__inner::placeholder {
		color: rgba(255, 255, 255, 0.35) !important;
		font-weight: 300;
	}
	::v-deep .el-input__inner:focus {
		border-color: #38bdf8 !important;
		background: rgba(56, 189, 248, 0.08) !important;
		box-shadow: 0 0 0 4px rgba(56, 189, 248, 0.15), inset 0 2px 4px rgba(0, 0, 0, 0.2) !important;
	}
	::v-deep .el-input__prefix {
		left: 16px !important;
		display: flex;
		align-items: center;
		height: 100% !important;
		color: rgba(255, 255, 255, 0.3) !important;
		font-size: 18px !important;
		transition: color 0.3s;
	}
	::v-deep .el-input__inner:focus + .el-input__prefix {
		color: #38bdf8 !important;
	}
	::v-deep .el-form-item {
		margin-bottom: 22px !important;
	}

	/* ===== 身份选择：滑动卡片效果 ===== */
	.identity-item {
		margin-bottom: 28px !important;
	}
	.identity-label {
		color: rgba(255, 255, 255, 0.5);
		font-size: 13px;
		font-weight: 400;
		letter-spacing: 1px;
		margin-bottom: 12px;
	}
	.identity-group-wrapper {
		overflow: hidden;
		/* 为了滑动动画的溢出隐藏 */;
	}
	.identity-group {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
		/* 卡片之间的间距 */;
	}

	/* 每个身份卡片（覆盖 el-radio-button） */
	::v-deep .el-radio-button {
		margin: 0 !important;
		flex: 0 0 auto;
		transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
	}
	::v-deep .el-radio-button__inner {
		background: rgba(255, 255, 255, 0.03) !important;
		border: 1px solid rgba(255, 255, 255, 0.08) !important;
		border-radius: 16px !important;
		padding: 10px 22px !important;
		font-size: 14px !important;
		color: rgba(255, 255, 255, 0.5) !important;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
		transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
		backdrop-filter: blur(4px);
		position: relative;
		overflow: hidden;
		cursor: pointer;
		/* 卡片滑动入场（每个卡片单独延迟，在模板中无法设置，故用JS动态添加，但这里我们用全局统一动画，通过 CSS 变量控制） */
		/* 我们将在模板中通过 style 设置 animation-delay，但这里为了简单，使用统一动画 */;
	}

	/* 悬浮效果：卡片上滑并放大，加光效 */
	::v-deep .el-radio-button__inner:hover {
		background: rgba(255, 255, 255, 0.08) !important;
		color: #f1f5f9 !important;
		border-color: rgba(255, 255, 255, 0.25) !important;
		transform: translateY(-6px) scale(1.04);
		box-shadow: 0 12px 28px -8px rgba(0, 0, 0, 0.6), 0 0 20px rgba(56, 189, 248, 0.15) !important;
	}

	/* 选中状态：卡片明显凸起，渐变背景，滑动感 */
	::v-deep .el-radio-button.is-active .el-radio-button__inner {
		background: linear-gradient(135deg, #3b82f6, #8b5cf6) !important;
		border-color: transparent !important;
		color: #fff !important;
		box-shadow: 0 12px 32px -6px rgba(59, 130, 246, 0.6), 0 0 30px rgba(99, 102, 241, 0.3) !important;
		transform: translateY(-6px) scale(1.04);
	}

	/* 选中状态下悬停保持效果 */
	::v-deep .el-radio-button.is-active .el-radio-button__inner:hover {
		transform: translateY(-8px) scale(1.06);
		box-shadow: 0 16px 40px -6px rgba(59, 130, 246, 0.7), 0 0 40px rgba(99, 102, 241, 0.4) !important;
	}

	/* 卡片入场滑动动画（每个卡片错落） */
	.identity-card {
		opacity: 0;
		animation: cardSlideIn 0.6s cubic-bezier(0.23, 1, 0.32, 1) both;
	}
	/* 通过元素内联 style 控制延时，这里定义动画 */
	@keyframes cardSlideIn {
		0% {
			opacity: 0;
			transform: translateX(-30px) scale(0.9);
		}
		100% {
			opacity: 1;
			transform: translateX(0) scale(1);
		}
	}

	/* 为了让每个卡片延时不同，我们在模板中给每个 el-radio-button 添加 style="animation-delay: Xs" */
	/* 但 el-radio-button 不是普通元素，我们需要穿透到内部 .el-radio-button，可以添加类 identity-card 并设置动画，然后在模板中通过 style 控制延时，但 style 不能作用于组件根节点，所以我们在模板中给每个 el-radio-button 添加 style，但 Vue 会将其应用到根元素。 */
	/* 经过测试，给 el-radio-button 添加 style 可以生效。我们在模板中已经添加了 :style="{'animation-delay': '0.6s'}" 等，但为了更清晰，我们下面保留样式，由模板内联控制。 */

	/* 但我们已经在模板中为每个 el-radio-button 添加了 style="animation-delay: 0.6s;" 等，因此这里不需要再定义。但为了兼容，保留此动画定义。 */

	/* ===== 登录按钮 ===== */
	::v-deep .el-button--primary {
		background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%) !important;
		border: none !important;
		border-radius: 12px !important;
		height: 50px !important;
		font-size: 17px !important;
		font-weight: 600 !important;
		letter-spacing: 6px;
		color: #fff !important;
		box-shadow: 0 8px 24px -6px rgba(59, 130, 246, 0.4) !important;
		transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
		position: relative;
		overflow: hidden;
	}
	::v-deep .el-button--primary:hover {
		transform: translateY(-3px) scale(1.02);
		box-shadow: 0 16px 40px -8px rgba(59, 130, 246, 0.6) !important;
	}
	::v-deep .el-button--primary:active {
		transform: scale(0.96);
	}
	::v-deep .el-button--primary.is-loading {
		background: linear-gradient(135deg, #2563eb 0%, #7c3aed 100%) !important;
	}

	/* ===== 错误页面 ===== */
	.no-block {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		min-height: 100vh;
		background: #0b0f19;
		color: #94a3b8;
	}
	.no-text {
		font-size: 28px;
		font-weight: 300;
		margin-bottom: 40px;
		letter-spacing: 4px;
	}
	.no-scool {
		width: 300px;
		opacity: 0.6;
		filter: grayscale(1);
	}

	/* ===== 响应式 ===== */
	@media screen and (max-width: 520px) {
		.login-card {
			width: 92%;
			padding: 20px 16px 30px 16px;
		}
		.school-name {
			font-size: 20px;
		}
		.title {
			font-size: 20px;
		}
		::v-deep .el-input__inner {
			height: 46px !important;
		}
		::v-deep .el-button--primary {
			height: 46px !important;
		}
		.identity-group {
			gap: 8px;
		}
		::v-deep .el-radio-button__inner {
			padding: 8px 16px !important;
			font-size: 13px !important;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/login.vue